import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
  MarkerType,
} from "@xyflow/react";
import * as EdgeCSS from "./edge.module.css";

export function DropEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
}: {
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  data: { label?: string };
}) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    borderRadius: 20,
  });

  return (
    <>
      <BaseEdge
        className={EdgeCSS.line}
        id={id}
        markerEnd={MarkerType.Arrow}
        path={edgePath}
      />
      <EdgeLabelRenderer>
        {data.label && (
          <div
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: "all",
            }}
          >
            <RedoBadge color="gray" text={data.label} />
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
}
